import React, { useState } from 'react';
import { postPublicRequest } from "../api/auth";
import API_ROUTES from "./config/apiConfig";

const inquiryTypes = [
  "Bulk Procurement",
  "Hospitality Project",
  "Custom Design Spec",
  "Export / Distribution",
  "General Inquiry"
];

export default function ContactUs() {
  const [submitted, setSubmitted] = useState(false);
  const [selectedType, setSelectedType] = useState("Bulk Procurement");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    try {
      const fullMessage = `
Inquiry Purpose: ${selectedType}
Address / City: ${formData.address || "Not provided"}

Message:
${formData.message}
      `;

      const payload = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        message: fullMessage,
      };

      const res = await postPublicRequest(
        API_ROUTES.CREATE_ENQUIRY,
        payload
      );

      if (res.success) {
        setSubmitted(true);
        setFormData({
          name: "",
          email: "",
          phone: "",
          address: "",
          message: "",
        });
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="contact-page-wrapper">
      {/* Background Ambient Glows */}
      <div className="contact-ambient-glow-1"></div>
      <div className="contact-ambient-glow-2"></div>

      {/* 1. HERO TITLE BLOCK */}
      <section className="contact-hero text-center">
        <div className="container animation-slide-up">
          <span className="contact-eyebrow">✧ DIRECT CLIENT DESK</span>
          <h1 className="contact-main-heading">
            Connect With Our
            <span className="contact-gold-text">Design & Procurement Team</span>
          </h1>
          <div className="contact-gold-divider"></div>
          <p className="contact-hero-desc">
            Whether scaling bespoke fixtures for a luxury resort or procuring handcrafted statement lamps for high-end retail spaces, our specialists are at your service.
          </p>
        </div>
      </section>

      {/* 2. CORE INFORMATION GRID */}
      <section className="container contact-main-grid">
        {/* Left Panel: Direct Channels & Showroom Info */}
        <div className="contact-details-column">
          <div className="info-block-item">
            <div className="info-icon-circle">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 21h18M5 21V7l8-4v18M13 7h6v14M9 9h1M9 13h1M9 17h1M16 11h1M16 15h1" />
              </svg>
            </div>
            <div className="info-text-box">
              <h3>Corporate Office & Showroom</h3>
              <p className="primary-text">Lightingale Creative Private Limited</p>
              <p>T-220, Gali No 01, Gautampuri, Delhi-53</p>
              <span className="landmark-tag">Near ADGITM College</span>
            </div>
          </div>

          <div className="info-block-item">
            <div className="info-icon-circle">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
            </div>
            <div className="info-text-box">
              <h3>Direct Hotline Connections</h3>
              <p>
                B2B Procurement: <a href="tel:+919350824043" className="highlight-link">+91 9350824043</a>
              </p>
              <p>
                Bulk Logistics: <a href="tel:+919350824043" className="highlight-link">+91 9350824043</a>
              </p>
            </div>
          </div>

          <div className="info-block-item">
            <div className="info-icon-circle">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect width="20" height="16" x="2" y="4" rx="2" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
              </svg>
            </div>
            <div className="info-text-box">
              <h3>Electronic Mail Inquiries</h3>
              <p>
                General Desk: <a href="mailto:bkksaj@gmail.com" className="highlight-link">bkksaj@gmail.com</a>
              </p>
              <p>
                Commercial Tenders: <a href="mailto:bkksaj@gmail.com" className="highlight-link">bkksaj@gmail.com</a>
              </p>
            </div>
          </div>

          <div className="info-block-item">
            <div className="info-icon-circle">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </div>
            <div className="info-text-box">
              <h3>Operating Architecture Hours</h3>
              <p>Monday – Saturday: 09:30 AM – 06:30 PM (IST)</p>
              <p className="dim-text">Closed on Sundays & Gazetted Holidays</p>
            </div>
          </div>

          {/* Instant WhatsApp Connect Card */}
          <div className="whatsapp-quick-card">
            <div className="whatsapp-quick-text">
              <h4>Need an Instant Response?</h4>
              <p>Connect with our product specialists directly on WhatsApp.</p>
            </div>
            <a
              href="https://wa.me/919350824043"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp-direct"
            >
              Chat on WhatsApp ➔
            </a>
          </div>
        </div>

        {/* Right Panel: Lead Capture Form */}
        <div className="contact-form-column">
          <div className="contact-form-card">
            {!submitted ? (
              <form className="contact-interactive-form" onSubmit={handleFormSubmit}>
                <div className="form-title-group">
                  <h3>Send A Direct Message</h3>
                  <p>Our team will review your specifications and reply within 24 business hours.</p>
                </div>

                {/* Purpose Selection Pills */}
                <div className="inquiry-type-selector">
                  <label>I Am Inquiring About:</label>
                  <div className="type-pills-row">
                    {inquiryTypes.map((type, idx) => (
                      <button
                        key={idx}
                        type="button"
                        className={`type-pill-btn ${selectedType === type ? "active" : ""}`}
                        onClick={() => setSelectedType(type)}
                      >
                        {type}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="contact-form-row">
                  <div className="contact-form-group">
                    <label>Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="e.g. Liam Sterling"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="contact-form-group">
                    <label>Email Address *</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="e.g. liam@luxuryhotel.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="contact-form-row">
                  <div className="contact-form-group">
                    <label>Phone / WhatsApp *</label>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="+91 93508 24043"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="contact-form-group">
                    <label>City / Location</label>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      placeholder="e.g. New Delhi / Dubai"
                    />
                  </div>
                </div>

                <div className="contact-form-group">
                  <label>Project Details & Requirements *</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    placeholder="Tell us about your project, expected order quantities, target timelines or custom requirements..."
                    required
                  />
                </div>

                <button type="submit" className="btn-contact-submit">
                  DISPATCH SECURE ENQUIRY ➔
                </button>
                <span className="contact-privacy-note">
                  🔒 Encrypted and confidential. We never share business details.
                </span>
              </form>
            ) : (
              <div className="contact-success-state text-center">
                <div className="success-check-badge">✓</div>
                <h3>Message Logged Successfully!</h3>
                <p>
                  Thank you for reaching out. A dedicated account manager has been assigned to your query and will connect with you shortly.
                </p>
                <button
                  type="button"
                  className="btn-contact-reset"
                  onClick={() => setSubmitted(false)}
                >
                  Submit Another Inquiry
                </button>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}